module.exports = __webpack_public_path__ + "img/iconBarrierGate.43435685.svg";